/**
 * Renders the page component
 */
import React from 'react';

import { Footer } from 'components/footer';
import { FinancialServiceJsonLd, OrganizationJsonLd } from 'components/jsonLd';
import { Menu } from 'components/menu';

import { Container } from 'theme/layout';

import { Page, PageProps } from './head';

/**
 * Core page wrapper for all content
 *
 * @param props - Render props
 */
export const StaticPage = React.forwardRef(function StaticPageComponent(
  props: PageProps,
  ref?: React.ForwardedRef<HTMLDivElement>
) {
  const { children, name, ...rest } = props;

  return (
    <Container ref={ref}>
      <Page name={name} {...rest}>
        <OrganizationJsonLd />
        <FinancialServiceJsonLd />
        <Menu />
        <Container>{children}</Container>
        <Footer
          cornerColorMobile={rest.cornerColorMobile}
          cornerColorDesktop={rest.cornerColorDesktop}
        />
      </Page>
    </Container>
  );
});
